import { render, staticRenderFns } from "./ProjectStatusOn.vue?vue&type=template&id=2c527a6b&scoped=true&"
import script from "./ProjectStatusOn.vue?vue&type=script&lang=ts&"
export * from "./ProjectStatusOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c527a6b",
  null
  
)

export default component.exports